import React from "react";
import { observer, inject } from "mobx-react";
import Container from "reactstrap/lib/Container";
import { SelectField } from "ComponentsUI/Selectfield";
import FiltersLoadParams from "HOC/FiltersLoadParams";
import { withRouter } from "react-router-dom";
import { generateUrl } from "Services/withDefaultParams";
import queryString from "query-string";
import ControlFilter from "../Components/ControlFilter";
var Routes = require("Configs/routes");

@withRouter
@inject("ApplicationModel")
@observer
export default class Filters extends FiltersLoadParams {
	constructor(props) {
		super(props);
		let text = this.props.ApplicationModel.text;
		let params = queryString.parse(props.location.search);
		this.state = {
			aggregation: this.props.aggregation,
			sort: [
				{
					id: 1,
					key: "",
					name: text.SORT_BY_DATE_1,
					down: true,
				},
				{
					id: 2,
					key: "date",
					name: text.SORT_BY_DATE_2,
					up: true,
				},
			],
		};
	}

	componentWillUnmount() {
		let {
			ApplicationModel: { filtersModel },
		} = this.props;
		filtersModel.reset();
	}

	onSort = (sort) => {
		const {
			location: { search },
			history,
		} = this.props;

		let ReviewsUrl = generateUrl(Routes.ProvidersReviewListOld.route, {
			regionUrl: this.props.match.params.regionUrl,
			providerName: this.props.match.params.providerName,
			page: this.props.match.params.page,
		});

		const getParams = queryString.parse(search);

		let urlArr = [];

		let activeSort = sort[0];

		if (!!activeSort.key) {
			getParams.sort = activeSort.key;
		} else {
			delete getParams.sort;
		}

		for (let key in getParams) {
			if (getParams[key]) {
				urlArr.push(`${key}=${getParams[key]}`);
			}
		}

		this.props.history.push({
			pathname: ReviewsUrl,
			search: `?${urlArr.join("&")}`,
		});
	};

	onFilterHandler = (items) => {
		let {
			ApplicationModel: { filtersModel },
			location: { search },
			match: { params },
		} = this.props;
		let parsedParams = queryString.parse(search);
		if (items.rating !== undefined) {
			if (!items.rating) {
				parsedParams.rating = "";
			} else {
				let ratings = !!parsedParams.rating ? parsedParams.rating.split(",") : [];
				let finded = ratings.find((item) => item === items.rating);
				if (finded) {
					ratings = ratings.filter((item) => item !== items.rating);
				} else {
					ratings.push(items.rating);
				}
				parsedParams.rating = ratings.length > 0 ? ratings.join(",") : undefined;
			}
		}

		if (items.specs !== undefined) {
			if (!items.specs) {
				parsedParams.specs = "";
			} else {
				let specs = !!parsedParams.specs ? parsedParams.specs.split(",") : [];
				let finded = specs.find((item) => item === items.specs);
				if (finded) {
					specs = specs.filter((item) => item !== items.specs);
				} else {
					specs.push(items.specs);
				}
				parsedParams.specs = specs.length > 0 ? specs.join(",") : undefined;
			}
		}

		if (items.withAnswer) {
			if (!!parsedParams.withAnswer) {
				delete parsedParams.withAnswer;
			} else {
				parsedParams.withAnswer = items.withAnswer;
			}
		}

		let ReviewsUrl = generateUrl(Routes.ProvidersReviewListOld.route, {
			regionUrl: params.regionUrl,
			providerName: params.providerName,
		});
		this.props.history.push({
			pathname: ReviewsUrl,
			search: queryString.stringify(parsedParams),
		});
	};

	onResetFilters() {
		this.onFilterHandler({
			rating: "",
			withAnswer: "",
			specs: "",
		});
	}

	onClickFeedbackHandler() {
		this.props.ApplicationModel.providerModel.setProviderFeedback(
			this.props.match.params.providerName
		);
	}

	render() {
		let {
			ApplicationModel: { ratesModel, text },
		} = this.props;

		let sortFinded = this.getSortFromParams(this.state.sort);

		let feedbackUrl = generateUrl(Routes.AddReview.route, {
			regionUrl: this.props.match.params.regionUrl,
		});

		let parsedParams = queryString.parse(this.props.location.search);

		// Закомментировано, чтобы не была возможность менять ориентацию через список отзывов у провайдера, т.к вызывает баг
		// let orientationChanger = (
		//     <OrientationChanger
		//         onChange={flat => ratesModel.setOrientation(flat)}
		//         flat={ratesModel.orientation}
		//     />
		// );

		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;

		let sort = (
			<SelectField
				multiselect={false}
				windowSizes={windowSizes}
				items={this.state.sort}
				onItemSelect={(items) => this.onSort(items)}
				text={text}
				findItems={sortFinded}
				placeholder={text.SORT_BY}
				activePlaceHolder={text.SORT_BY}
				onlyInputDisabled={true}
				withoutClose={true}
			/>
		);

		return (
			<Container>
				<ControlFilter
					provider={this.props.provider}
					params={parsedParams}
					onFilterHandler={(value) => this.onFilterHandler(value)}
					sort={sort}
					text={text}
					// orientationChanger={orientationChanger}
				/>
			</Container>
		);
	}
}
